import cn from "classnames";

import { TypographyProps, Variants, Weights } from "./Typography.types";

import styles from "./Typography.module.scss";

const VARIANTS: Variants = {
  h1: styles.h1,
  h2: styles.h2,
  h3: styles.h3,
  h4: styles.h4,
  h5: styles.h5,
  bodyL: styles.bodyL,
  bodyM: styles.bodyM,
  bodyS: styles.bodyS,
  bodyXS: styles.bodyXS,
  bodyXXS: styles.bodyXXS,
  numbers: styles.numbers,
};

const WEIGHTS: Weights = {
  light: styles.light,
  regular: styles.regular,
  medium: styles.medium,
  semiBold: styles.semiBold,
  bold: styles.bold,
};

const Typography = ({
  className,
  children,
  variant = "bodyL",
  weight = "regular",
  component,
  withHTML = false,
  ...restProps
}: TypographyProps) => {
  const Component = component || "p";

  if (withHTML) {
    return (
      <Component
        {...restProps}
        dangerouslySetInnerHTML={{ __html: children }}
        className={cn(
          styles.typography,
          VARIANTS[variant],
          WEIGHTS[weight],
          className
        )}
      />
    );
  }

  return (
    <Component
      {...restProps}
      className={cn(
        styles.typography,
        VARIANTS[variant],
        WEIGHTS[weight],
        className
      )}
    >
      {children}
    </Component>
  );
};

export default Typography;
